import React from 'react';

const BushButton = ({ styles, onClick, children, type = "button" }) => {
  return (
    <button
      className={`rounded-full transition-all duration-200 hover:scale-[1.04] ${styles}`}
      onClick={onClick}
      type={type}
    >
      {children}
    </button>
  );
};

export default BushButton;
